export default __webpack_public_path__ + "static/info-background-abba3299b0e0ee00cfbf0fa9af2ea83f.webp";